import { useEffect, useState } from "react";

/**
 * 값 변경을 지연시켜 불필요한 API 호출을 막는 디바운스 훅.
 * @param value 디바운스할 값
 * @param delay 지연 시간 (ms, 기본 300)
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
